import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";

function LoginProfileView({
  onBack,
  submitUserName,
  handleFieldChange,
  firstName,
  lastName,
}) {
  const { t } = useTranslation("auth");
  const [avatar, setAvatar] = React.useState("");

  React.useEffect(() => {
    document.querySelector('input[name="firstName"]')?.focus();
  }, []);

  const selectFile = (e, edit, handler) => {
    e.preventDefault();
    e.stopPropagation();
    const avatarInput = document.getElementById("avatar-input");
    if (avatar === "" || edit) {
      avatarInput.click();
    } else {
      setAvatar("");
      avatarInput.value = "";
      handler(avatarInput);
    }
  };

  const handleAvatarChange = (e, handler) => {
    e.persist();
    if (typeof e.target.files[0] === "object") {
      setAvatar(e.target.files[0]);
      handler(e);
      const reader = new FileReader();
      const img = document.getElementById("avatar");
      if (img) reader.onload = (event) => (img.src = event.target.result);
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <LoginWrapper
      mainClass="Onboarding athlete"
      left={
        <form method="POST" data-noreset onSubmit={submitUserName}>
          <BackArrowButton onBack={(_) => onBack(0)} />
          <div>
            <h1 className="mb-28!">{t("loginProfile.title")}</h1>
          </div>

          <section className="flex! justify-center mb-12">
            <div
              onClick={(e) => selectFile(e, true, handleFieldChange)}
              className="avatar-wrapper"
            >
              <div className="upload-icon-wrapper">
                <div className="upload-icon"></div>
              </div>
              {avatar !== "" && (
                <div
                  className="upload-icon-wrapper remove-wrapper"
                  onClick={(e) => selectFile(e, false, handleFieldChange)}
                >
                  <div className="remove-icon"></div>
                </div>
              )}
              {avatar === "" ? (
                <SvgIcon src="/img/new-icons/vuesax-linear-user.svg" />
              ) : (
                <img id="avatar" className="avatar" src={""} alt="" />
              )}
            </div>

            <input
              id="avatar-input"
              className="hidden"
              type="file"
              name="avatar"
              placeholder={t("loginProfile.addProfilePicture")}
              accept="image/*"
              onChange={(e) => handleAvatarChange(e, handleFieldChange)}
            />
          </section>

          <label htmlFor="firstName">{t("loginProfile.firstNameLabel")}</label>
          <input
            type="text"
            name="firstName"
            placeholder={t("loginProfile.firstNamePlaceholder")}
            value={firstName}
            required
            onChange={handleFieldChange}
            sz="large"
          />

          <label htmlFor="lastName" className="mt-6">
            {t("loginProfile.lastNameLabel")}
          </label>
          <input
            type="text"
            name="lastName"
            placeholder={t("loginProfile.lastNamePlaceholder")}
            value={lastName}
            required
            onChange={handleFieldChange}
            sz="large"
          />

          <button
            data-button-type="primary"
            sz="large"
            onClick={submitUserName}
          >
            {t("loginProfile.continue")}
          </button>
        </form>
      }
    />
  );
}

export default LoginProfileView;
